import http from './http.service';

class AgendaService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/hallScheduler";
    }

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getById/${id}`);
    };

    loadForEvent(eventId) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        return this.$http.get(`${this.baseUrl}/loadForEvent/${eventId}`);
    }

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}`, model);
    };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}`, model);
    };

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}`, { params: { id: id } });
    };
}

export default new AgendaService();
